export default __webpack_public_path__ + "static/media/try-atomic-energy-form.f3d38da8.png";